module.exports = __webpack_public_path__ + "static/media/saved64b16981.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/saved.svg
// module id = 654
// module chunks = 0